export const Loader = function () {
	this.toggle = (elem) => {
		const $loader = elem.find('.nx-loader');

		if ($loader.length > 0) {
			$loader.toggleClass('active');
		}
	};

	this.show = (elem) => {
		const $loader = elem.find('.nx-loader');

		if ($loader.length > 0) {
			$loader.addClass('active');
		}
	};

	this.hide = (elem) => {
		const $loader = elem.find('.nx-loader');

		if ($loader.length > 0) {
			$loader.removeClass('active');
		}
	};
};
